<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ایجاد سوال جدید </template>
    <BRow>
      <BCol cols="12" md="6">
        <CoursePicker
          @getCourse="setCourseId"
          @getCourseTypeId="setCourseTypeId"
        ></CoursePicker>
      </BCol>
      <BCol cols="12" md="6">
        <LessonPicker
          :defaultCourseId="courseId"
          @getLesson="setLessonId"
        ></LessonPicker>
      </BCol>
      <BCol cols="12" md="6">
        <QuestionLevelPicker
          v-model="questionDetails.questionLevel"
        ></QuestionLevelPicker>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="questionTitle"
          inputLabel="متن سوال را وارد کنید"
          inputPlaceholder="متن سوال"
          v-model="questionDetails.questionText"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <TextInput
          customRules="required|min:1"
          inputId="periodTime"
          inputLabel="زمان مورد نیاز برای پاسخ به سوال (دقیقه)"
          inputPlaceholder="زمان (دقیقه)"
          v-model.number="questionDetails.periodTime"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerA"
          inputLabel="متن گزینه A"
          inputPlaceholder="A"
          v-model="questionDetails.a"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerB"
          inputLabel="متن گزینه B"
          inputPlaceholder="B"
          v-model="questionDetails.b"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerC"
          inputLabel="متن گزینه C"
          inputPlaceholder="C"
          v-model="questionDetails.c"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerD"
          inputLabel="متن گزینه D"
          inputPlaceholder="D"
          v-model="questionDetails.d"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <p>جواب صحیح را انتخاب کنید</p>
        <div class="d-flex" style="gap: 1.5rem">
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="a"
            v-model="questionDetails.correctAnswer"
          >
            A
          </BFormRadio>
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="b"
            v-model="questionDetails.correctAnswer"
          >
            B
          </BFormRadio>
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="c"
            v-model="questionDetails.correctAnswer"
          >
            C
          </BFormRadio>
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="d"
            v-model="questionDetails.correctAnswer"
          >
            D
          </BFormRadio>
        </div>
      </BCol>
      <BCol cols="auto" class="ml-auto">
        <BButton @click="createNewQuestion" variant="primary"> ثبت </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  watch: {
    isDescriptive: {
      handler(val) {
        this.questionDetails = {
          isDeleted: false,
          questionId: 0,
          questionText: null,
          correctAnswer: null,
          correctLongAnswer: null,
          createDate: new Date(Date.now()),
          a: null,
          b: null,
          c: null,
          d: null,
          lessonId: null,
          periodTime: null,
        };
      },
    },
  },
  data() {
    return {
      isLoading: false,
      isDescriptive: false,
      questionDetails: {
        isDeleted: false,
        questionId: 0,
        questionText: null,
        correctAnswer: null,
        correctLongAnswer: null,
        courseTypeId: null,
        createDate: new Date(Date.now()),
        a: null,
        b: null,
        c: null,
        d: null,
        lessonId: null,
        periodTime: null,
        questionLevel: 1,
      },
      courseId: null,
    };
  },
  methods: {
    setLessonId(lessonId) {
      this.questionDetails.lessonId = lessonId;
    },
    setCourseTypeId(courseTypeId) {
      this.questionDetails.courseTypeId = courseTypeId;
    },
    setCourseId(courseId) {
      this.courseId = courseId;
    },
    async createNewQuestion() {
      let _this = this;
      let createQuestion = new CreateQuestion(_this);
      createQuestion.setParams(_this.questionDetails);
      await createQuestion.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد",
                icon: "CheckIcon",
                variant: "success",
                text: "سوال با موفقیت ایجاد شد",
              },
            });
            _this.questionDetails = {
              isDeleted: false,
              questionId: 0,
              questionText: null,
              correctAnswer: null,
              correctLongAnswer: null,
              courseTypeId: _this.questionDetails.courseTypeId,
              createDate: new Date(Date.now()),
              a: null,
              b: null,
              c: null,
              d: null,
              lessonId: _this.questionDetails.lessonId,
              periodTime: null,
              questionLevel: _this.questionDetails.questionLevel,
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "CheckIcon",
                variant: "success",
                text:
                  response.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
  },
  components: {
    PageWrapper,
    TextInput,
    CoursePicker,
    LessonPicker,
    QuestionLevelPicker,
    BRow,
    BCol,
    BFormRadio,
    BButton,
  },
};
import TextInput from "@/views/components/Utils/TextInput.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import LessonPicker from "@/views/components/Lessons/LessonPicker.vue";
import CoursePicker from "@/views/components/MasterActiveCourse/CoursePicker.vue";
import QuestionLevelPicker from "@/views/components/Questions/QuestionLevelPicker.vue";
import { BRow, BCol, BFormRadio, BButton } from "bootstrap-vue";
import { CreateQuestion } from "../../../libs/Api/Question";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
